module.exports = __webpack_public_path__ + "media/Schletzfertig.2137adcf.mp4";